import Head from "next/head"
import React from "react"

import Footer from "~/components/organisms/Footer"
import AuthRegisterCompletePage from "~/components/pages/AuthRegisterCompletePage"

const RegisterComplete = () => {
  return (
    <>
      <Head>
        <title>新規登録完了 | Infra（インフラ）</title>
      </Head>
      <AuthRegisterCompletePage />
      <Footer />
    </>
  )
}

export default RegisterComplete
